<template>
    <svg :width="width" :height="height" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_43_89)">
    <path d="M23.7968 5.67212H19.5783C19.19 5.67212 18.8752 5.98692 18.8752 6.37522C18.8752 6.76351 19.19 7.07831 19.5783 7.07831H22.0995L13.2504 15.9274L8.12279 10.7997C7.84825 10.5251 7.40305 10.5251 7.12846 10.7997L0.725308 17.1276C0.450725 17.4022 0.413836 17.8473 0.688419 18.1219C0.962955 18.3965 1.44505 18.3965 1.71963 18.1219L7.62565 12.2912L12.7533 17.4188C13.0278 17.6934 13.473 17.6934 13.7476 17.4188L23.0938 8.07264V10.5938C23.0938 10.9821 23.4086 11.2969 23.7969 11.2969C24.1852 11.2969 24.5 10.9821 24.5 10.5938V6.37545C24.5002 5.97675 24.173 5.67212 23.7968 5.67212Z" :fill="color" :fill-opacity="opacity"/>
    </g>
    <defs>
    <clipPath id="clip0_43_89">
    <rect :width="width" :height="height" :fill="color" :fill-opacity="opacity" transform="translate(0.5)"/>
    </clipPath>
    </defs>
    </svg>

</template>

<script>
export default {
	name: "RisingStarIcon",
	props: {
		height: {
			type: Number,
			default: 24
		},
		width: {
			type: Number,
			default: 24
		},
        color: {
            type: String,
            default: 'white'
        },
        opacity: {
            type: String,
            default: ''
        }
  	}
}
</script>
